import Year2020Address from '@/views/year2020/address'
export default {
    path: '/address',
    name: 'Year2020Address',
    component: Year2020Address,
    description: '收货地址填写'
}